<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" fill="none">
    <path
      d="M29.477 16.7385C29.477 23.7738 23.7738 29.477 16.7385 29.477C9.70321 29.477 4 23.7738 4 16.7385C4 9.70321 9.70321 4 16.7385 4C23.7738 4 29.477 9.70321 29.477 16.7385Z"
      stroke="#2B33FF"
      stroke-width="7.3045"
    />
  </svg>
</template>
